/**
 * @classdesc Danish Language Pack
 * @desc This class will used to translate tokens into the Danish language.
 * @namespace Languages.Danish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Danish
 */
export const dictionary = {
	'years'   : 'År',
	'months'  : 'Måneder',
	'days'    : 'Dage',
	'hours'   : 'Timer',
	'minutes' : 'Minutter',
	'seconds' : 'Sekunder'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Danish
 */
export const aliases = ['da', 'da-dk', 'danish'];
